import React from "react"
import {Icon} from "semantic-ui-react";

const styles = {
    containerField: {
        display: 'flex'
    },
    textField: {
        marginLeft: '5px',
        fontSize: '0.8em',
    }
}

const textField = (field) => ({
    fontWeight:600,
    color: field === true ? '#ab1a1a' : '#ab1a1a'
});

const ContainerFieldPrescriptionUrgent = ({ label, icon, field, extra, style }) => {

    if( field === true )
    {
        return (
            <div style={{...styles.containerField, ...style }}>
                {
                    icon !== undefined && icon
                }
                <span style={styles.textField}>
                <Icon className="warningIcon" size="small" name="warning" circular style={{position:'relative',bottom:2, marginLeft:3}}/> {label} &nbsp;

                    <span style={textField(field)}>
                    {field !== null ? field : ' - '}
                </span>
                <span style={textField(field)}>
                    {extra !== null ? extra : ''}
                </span>
            </span>
            </div>
        )
    }
    else {
        return <div>&nbsp;</div>
    }


};

export default ContainerFieldPrescriptionUrgent